import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {TypographyProps, withStyles} from '@material-ui/core';

const StyledTypography = withStyles<string, undefined, TypographyProps>(theme => ({
    root: {
        fontWeight: 'normal',
        // @ts-ignore
        color: theme.palette.dividerStrong
    }
}))(Typography);

const DataUnavailableBox = ({
    title,
    previousValue,
    tooltip
}: {
    title: string;
    previousValue?: number | string;
    tooltip?: JSX.Element | string;
}) => (
    <Box display="flex" alignItems="center">
        {previousValue ? (
            <StyledTypography noWrap variant="h3">
                {previousValue}
            </StyledTypography>
        ) : (
            <Box display="flex" alignItems="center" height={51}>
                <Typography variant="body2" style={{color: '#FFA640'}}>
                    {title}
                </Typography>
            </Box>
        )}
        {tooltip}
    </Box>
);

export default DataUnavailableBox;
